import React from "react";
import watchImg from "./../../../assets/2106235_sw6_coverHover_2k.jpg";
import { Button } from "reactstrap";
import "./../../../App.css";
export default function WishResponse({ display, setDisplay, offer }) {
  console.log('OFFFFFFFFFFFFFFFFFFFFFFFFFER:   ', offer)
  return (
    <div
      className="container wishResponses"
      style={display ? {border: 'none'} : { display: "none" }}
    >
      {/*<div className="d-flex justify-content-between align-items-baseline mt-2">
        <h2>
          For Wish(es) <span>X</span>
        </h2>
        <Button
          outline
          color="dark"
          onClick={() => {
            setDisplay(false);
          }}
        >
          X
        </Button>
      </div>*/}
      <ul>
        <li>
          <div className="resDescTextContainer">
            <p className="" style={{maxWidth: '350px'}}>{offer.description}</p>
            {offer.itemContains && <p>Watch contains: {offer.itemContains} </p>}
            {offer.externalURL && <a href={offer.externalURL} target="_blank" rel="noreferrer">More info</a>}
          </div>
          <div className="ResImgsContainer">
            {offer.photoURLs? offer.photoURLs.length < 1 ? 
            <>
            <img src={watchImg} alt="watch" />
            <img src={watchImg} alt="watch" />
            <img src={watchImg} alt="watch" />
            </>
            :
            offer.photoURLs.map((url) =>{
              return <img src={url} alt='Watch' />
            })
            :            <>
            <img src={watchImg} alt="watch" />
            <img src={watchImg} alt="watch" />
            <img src={watchImg} alt="watch" />
            </>
          }
          </div>
          <div className="resPricesContainer">
            <p>
              price: <span>{offer.priceSale} €</span>
            </p>
            <p>
              Min price: <span>{offer.priceMinimum} €</span>
            </p>
          </div>
          <div className="resAction">
            <Button outline color="secondary">
              Confirm
            </Button>
            <Button outline color="danger">
              Decline
            </Button>
          </div>
        </li>
        
      </ul>
    </div>
  );
}
